<template>
  <div class="my-5" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-9' : 'px-5'">
    <v-dialog v-model="dialog.marketing" 
      persistent
      width="1200">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 text-first d-flex blue-grey lighten-5 pb-0">
          <span>
            Marketing Penjualan Terbanyak ({{ filter.marketing === 'ppjb' ? 'PPJB' : 'AJB' }})
          </span>
          <v-spacer/>
          <v-icon color="red" @click="dialog.marketing = false; reset();">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="blue-grey lighten-5">
          <v-row justify="end">
            <v-col cols="12" md="6">
              <v-select
                outlined
                dense
                item-color="green lighten-2"
                single-line
                :hide-details="true"
                label="Semua Proyek"
                :items="project"
                item-text="project_name"
                item-value="project_id"
                v-model="filter.project_id">
                <template v-slot:append>
                  <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" md="3">
              <v-select
                outlined
                dense
                item-color="green lighten-2"
                single-line
                :hide-details="true"
                label="Tahun"
                :items="years_starts"
                v-model="filter.year">
                <template v-slot:append>
                  <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" md="3">
              <v-select
                outlined
                dense
                item-color="green lighten-2"
                single-line
                :hide-details="true"
                label="Bulan"
                :items="months_starts"
                item-text="label"
                item-value="value"
                v-model="filter.month">
                <template v-slot:append>
                  <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text class="px-0">
          <v-skeleton-loader
            class="ma-auto"
            min-height="525"
            :loading="process.run"
            transition="scale-transition"
            :tile="false"
            type="table">
            <v-simple-table :style="pagination.total_page > 0 ? 'min-height: 500px;' : ''">
              <template v-slot:default class="border-h">
                <tbody>
                  <tr v-for="(item, index) in process.run ? 7 : list" 
                    :key="index">
                    <td class="caption text-second">
                      <v-avatar color="#E0E0E0" tile class="ma-2 rounded">
                        {{ item.user_name | initial }}
                      </v-avatar>
                      {{ item.user_name }}
                    </td>
                    <td class="caption text-second">
                      {{ item.unit }} Unit
                    </td>
                    <td class="caption text-second text-right">
                      {{ parseInt(item.nominal) | price }}
                    </td>
                    <td class="caption green--text text-right">
                      <span class="cursor-pointer" 
                        @click="detailPpjbajb = item; dialog.ppjbajb = true; fetchPpjbajbDetail();">
                        Lihat unit yang dijual
                      </span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-skeleton-loader>
          <v-row justify="center" align="center" v-if="!process.run && pagination.total_page < 1">
            <v-col cols="12" class="d-flex align-center my-12 py-12">
              <v-img 
                class="my-12"
                contain
                width="200"
                height="200"
                :src="require('../../assets/404/404.svg')">
              </v-img>
            </v-col>
          </v-row>
          <v-divider/>
        </v-card-text>

        <v-card-text>
          <v-row justify="end" align="center" v-if="pagination.total_page > 1">
            <v-col cols="12" md="2" class="d-flex align-center justify-end">
              <v-btn
                color="#4FC3F7"
                :disabled="pagination.current === 1"
                elevation="3"
                min-width="36"
                class="text-capitalize white--text px-0 mr-3"
                @click="selected.pagination = 1">
                <v-icon>mdi-chevron-double-left</v-icon>
              </v-btn>
              <v-btn
                color="#263238"
                :disabled="pagination.current < 2"
                elevation="3"
                min-width="36"
                class="text-capitalize white--text px-0"
                @click="selected.pagination = selected.pagination-1">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <div class="mx-5" style="width: 75px;">
                <v-autocomplete
                  v-model="selected.pagination"
                  :items="pagination.detail"
                  color="#263238"
                  auto-select-first
                  outlined
                  dense
                  single-line
                  hide-details
                  hide-selected>
                  <template v-slot:selection="{ item }">
                    {{ item }}
                  </template>
                </v-autocomplete>
              </div>
              <v-btn
                color="#263238"
                elevation="3"
                min-width="36"
                class="text-capitalize white--text px-0"
                :disabled="pagination.current >= pagination.total_page"
                @click="selected.pagination = selected.pagination+1">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
              <v-btn
                color="#4FC3F7"
                :disabled="pagination.current === pagination.total_page"
                elevation="3"
                min-width="36"
                class="text-capitalize white--text px-0 ml-3"
                @click="selected.pagination = pagination.total_page">
                <v-icon>mdi-chevron-double-right</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.ppjbajb" 
      persistent
      width="750">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 text-first d-flex blue-grey lighten-5 pb-0">
          <div>
            <p class="mb-1">
              {{ filter.marketing === 'ppjb' ? 'PPJB' : 'AJB' }} - {{ detailPpjbajb.user_name }}
            </p>
            <p class="caption text-third">
              Sampai Dengan <b>{{ dateNow | date }}</b>
            </p>
          </div>
          <v-spacer/>
          <div class="text-right">
            <p class="mb-1">
              {{ detailPpjbajb.unit }}
              <span class="text-third">
                Unit
              </span>
            </p>
            <p class="caption text-second">
              {{ parseInt(detailPpjbajb.nominal) | price }}
            </p>
          </div>
        </v-card-title>
        <v-card-text class="px-0 pb-0">
          <v-skeleton-loader
            class="ma-auto"
            min-height="300"
            :loading="process.detail"
            transition="scale-transition"
            :tile="false"
            type="table">
            <v-simple-table style="min-height: 300px;">
              <template v-slot:default>
                <tbody>
                  <tr v-for="(item, index) in process.detail ? 7 : listDetail" 
                    :key="index">
                    <td class="caption text-second">
                      <v-avatar color="#E0E0E0" tile class="ma-2 rounded">
                        {{ item.transaction_project_name | initial }}
                      </v-avatar>
                      {{ item.transaction_project_name }}
                    </td>
                    <td class="caption text-second">
                      Tipe Unit - {{ item.unit_type_name }}
                    </td>
                    <td class="caption text-second">
                      {{ item.unit }} Unit
                    </td>
                    <td class="caption text-second text-right">
                      {{ parseInt(item.nominal) | price }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-skeleton-loader>
          <v-row justify="center" align="center" v-if="!process.detail && listDetail.length < 1">
            <v-col cols="12" class="d-flex align-center my-12 py-12">
              <v-img 
                class="my-12"
                contain
                width="200"
                height="200"
                :src="require('../../assets/404/404.svg')">
              </v-img>
            </v-col>
          </v-row>
          <v-divider/>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            text
            color="red"
            class="text-capitalize"
            @click="detailPpjbajb = {}; dialog.ppjbajb = false;">
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog  v-model="dialog.unit" 
      persistent
      width="1200">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 text-first d-flex blue-grey lighten-5 pb-0">
          <span>
            Unit Yang Banyak Terjual
          </span>
          <v-spacer/>
          <v-icon color="red" @click="dialog.unit = false; reset();">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="blue-grey lighten-5">
          <v-row justify="end">
            <v-col cols="12">
              <v-select
                outlined
                dense
                item-color="green lighten-2"
                single-line
                :hide-details="true"
                label="Semua Proyek"
                :items="project"
                item-text="project_name"
                item-value="project_id"
                v-model="filter.project_id">
                <template v-slot:append>
                  <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="px-0">
          <v-skeleton-loader
            class="ma-auto"
            min-height="525"
            :loading="process.run"
            transition="scale-transition"
            :tile="false"
            type="table">
            <v-simple-table :style="pagination.total_page > 0 ? 'min-height: 500px;' : ''">
              <template v-slot:default>
                <tbody>
                  <tr v-for="(item, index) in process.run ? 7 : list" 
                    :key="index">
                    <td class="caption text-second">
                      <v-avatar color="#E0E0E0" tile class="ma-2 rounded">
                        {{ item.project_name | initial }}
                      </v-avatar>
                      {{ item.project_name }}
                    </td>
                    <td class="caption text-second">
                      Tipe Unit - {{ item.unit_type_name }}
                    </td>
                    <td class="caption text-second">
                      Terjual {{ item.unit_type_sold_unit }} Unit
                    </td>
                    <td class="caption text-second">
                      Total {{ item.unit_type_total_unit }} Unit
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-skeleton-loader>
          <v-row justify="center" align="center" v-if="!process.run && pagination.total_page < 1">
            <v-col cols="12" class="d-flex align-center my-12 py-12">
              <v-img 
                class="my-12"
                contain
                width="200"
                height="200"
                :src="require('../../assets/404/404.svg')">
              </v-img>
            </v-col>
          </v-row>
          <v-divider/>
        </v-card-text>
        <v-card-text>
          <v-row justify="end" align="center" v-if="pagination.total_page > 1">
            <v-col cols="12" md="2" class="d-flex align-center justify-end">
              <v-btn
                color="#4FC3F7"
                :disabled="pagination.current === 1"
                elevation="3"
                min-width="36"
                class="text-capitalize white--text px-0 mr-3"
                @click="selected.pagination = 1">
                <v-icon>mdi-chevron-double-left</v-icon>
              </v-btn>
              <v-btn
                color="#263238"
                :disabled="pagination.current < 2"
                elevation="3"
                min-width="36"
                class="text-capitalize white--text px-0"
                @click="selected.pagination = selected.pagination-1">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <div class="mx-5" style="width: 75px;">
                <v-autocomplete
                  v-model="selected.pagination"
                  :items="pagination.detail"
                  color="#263238"
                  auto-select-first
                  outlined
                  dense
                  single-line
                  hide-details
                  hide-selected>
                  <template v-slot:selection="{ item }">
                    {{ item }}
                  </template>
                </v-autocomplete>
              </div>
              <v-btn
                color="#263238"
                elevation="3"
                min-width="36"
                class="text-capitalize white--text px-0"
                :disabled="pagination.current >= pagination.total_page"
                @click="selected.pagination = selected.pagination+1">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
              <v-btn
                color="#4FC3F7"
                :disabled="pagination.current === pagination.total_page"
                elevation="3"
                min-width="36"
                class="text-capitalize white--text px-0 ml-3"
                @click="selected.pagination = pagination.total_page">
                <v-icon>mdi-chevron-double-right</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog  v-model="dialog.filter" 
      persistent
      width="500">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 text-first d-flex blue-grey lighten-5">
          <span>
            Filter Dashboard
          </span>
          <v-spacer/>
          <v-icon color="red" @click="dialog.filter = false; reset();">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="mt-6">
          <v-radio-group
            v-model="filter.dialog.periode"
            row>
            <v-radio
              v-for="(item, index) in type"
              :key="index"
              :label="item.label"
              :value="item.value"
              :color="style.primary">
            </v-radio>
          </v-radio-group>
          
          <v-row v-if="filter.dialog.periode !== 'date'">
            <v-col cols="12" md="6">
              <v-select
                outlined
                dense
                item-color="green lighten-2"
                :hide-details="true"
                label="Tahun Mulai"
                :items="years_starts"
                v-model="filter.dialog.year_start">
                <template v-slot:append>
                  <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                outlined
                dense
                item-color="green lighten-2"
                :hide-details="true"
                label="Tahun Selesai"
                :disabled="filter.dialog.year_start === ''"
                :items="years_ends"
                v-model="filter.dialog.year_end">
                <template v-slot:append>
                  <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                </template>
              </v-select>
            </v-col>
          </v-row>

          <v-row v-if="filter.dialog.periode === 'month'">
            <v-col cols="12" md="6">
              <v-select
                outlined
                dense
                item-color="green lighten-2"
                :hide-details="true"
                label="Bulan Mulai"
                :items="months_starts"
                item-text="label"
                item-value="value"
                v-model="filter.dialog.month_start">
                <template v-slot:append>
                  <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                outlined
                dense
                item-color="green lighten-2"
                :hide-details="true"
                label="Bulan Selesai"
                :disabled="filter.dialog.month_start === ''"
                :items="months_ends"
                item-text="label"
                item-value="value"
                v-model="filter.dialog.month_end">
                <template v-slot:append>
                  <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                </template>
              </v-select>
            </v-col>
          </v-row>

          <v-row v-if="filter.dialog.periode === 'date'">
            <v-col cols="12" md="6">
              <v-menu
                ref="start"
                min-width="290px"
                max-width="290px"
                transition="scale-transition"
                offset-y
                :nudge-right="40"
                :close-on-content-click="false"
                v-model="picker.start">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    dense
                    outlined
                    readonly
                    :color="style.primary"
                    prepend-inner-icon="mdi-calendar-month"
                    label="Tanggal Mulai"
                    v-model="filter.dialog.date_start"
                    v-on="on">
                  </v-text-field>
                </template>
                <v-date-picker 
                  :color="style.primary"
                  v-model="filter.dialog.date_start"
                  @input="picker.start = false">
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="6">
              <v-menu
                ref="start"
                min-width="290px"
                max-width="290px"
                transition="scale-transition"
                offset-y
                :nudge-right="40"
                :close-on-content-click="false"
                v-model="picker.end">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    dense
                    outlined
                    readonly
                    :color="style.primary"
                    prepend-inner-icon="mdi-calendar-month"
                    label="Tanggal Selesai"
                    :disabled="filter.dialog.date_start === ''"
                    v-model="filter.dialog.date_end"
                    v-on="on">
                  </v-text-field>
                </template>
                <v-date-picker 
                  :color="style.primary"
                  v-model="filter.dialog.date_end"
                  @input="picker.end = false">
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-6 pb-6">
          <v-spacer/>
          <v-btn
            dark
            :color="style.primary"
            class="text-capitalize"
            @click="dialog.filter = false; fetchDashboard();">
            <v-icon small class="mr-1">mdi-magnify</v-icon>
            Cari
          </v-btn>
          <v-btn 
            dark
            outlined
            color="red"
            class="text-capitalize"
            @click="dialog.filter = false; reset(); fetchDashboard();">
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row justify="end">
      <v-col cols="12" md="3">
        <v-select
          outlined
          dense
          item-color="green lighten-2"
          single-line
          :hide-details="true"
          label="Semua Proyek"
          :items="project"
          item-text="project_name"
          item-value="project_id"
          v-model="filter.project_id">
          <template v-slot:append>
            <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
          </template>
        </v-select>
      </v-col>
      <v-col cols="12" md="9" class="text-right">
        <!-- <v-btn
          dark
          :color="style.primary"
          class="text-capitalize"
          @click="dialog.filter = true;">
          Filter
          <v-icon small class="ml-1">mdi-filter-variant</v-icon>
        </v-btn> -->
      </v-col>
    </v-row>
    
    <v-row>
      <v-col cols="12" md="4"
        v-for="(item, index) in top"
        :key="index">
        <v-card
          min-height="160"
          class="box-shadow border-radius"
          :to="filter.project_id === '' ? `/project` : `/project/detail/${filter.project_id}`">
          <v-list-item three-line>
            <v-list-item-content class="pa-0">
              <v-list-item-title>
                <v-icon style="font-size: 60px;" :color="item.color">{{ item.icon }}</v-icon>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-avatar class="mb-0">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="grey" 
                    v-bind="attrs"
                    v-on="on">
                    mdi-information-outline
                  </v-icon>
                </template>
                <span>
                  {{ item.desc }}
                </span>
              </v-tooltip>
            </v-list-item-avatar>
          </v-list-item>
          <v-card-actions class="py-0">
            <div style="width: 150px;">
              <v-card-title class="text-third justify-center text-center pa-0" style="font-size: 10px;">
                {{ item.project.title}}
              </v-card-title>
              <v-card-text class="headline text-second text-center">
                {{ item.project.total }}
              </v-card-text>
            </div>
            <v-spacer/>
            <v-divider vertical class="my-4"/>
            <v-spacer/>
            <div style="width: 150px;">
              <v-card-title class="text-third justify-center text-center pa-0" :class="`${item.type.color}--text`" style="font-size: 10px;">
                {{ item.type.title}}
              </v-card-title>
              <v-card-text class="headline text-center" :class="`${item.type.color}--text`">
                {{ item.type.total }}
              </v-card-text>
            </div>
            <v-spacer/>
            <v-divider vertical class="my-4"/>
            <v-spacer/>
            <div style="width: 150px;">
              <v-card-title class="text-third justify-center text-center pa-0" :class="`${item.unit.color}--text`" style="font-size: 10px;">
                {{ item.unit.title}}
              </v-card-title>
              <v-card-text class="headline text-center" :class="`${item.unit.color}--text`">
                {{ item.unit.total }}
              </v-card-text>
            </div>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    
    <v-row justify="end">
      <v-col cols="12" md="8">
        <v-row>
          <v-col cols="12">
            <v-card
              class="border-radius box-shadow pa-2 py-0">
              <v-card-title class="body-2 text-second">
                Ringkasan Pemasukan
              </v-card-title>
              <v-card-subtitle class="caption text-third pb-2">
                Sampai Dengan <b>{{ dateNow | date }}</b>
              </v-card-subtitle>
              <v-row>
                <v-col cols="12" md="8" class="pr-8">
                  <div>
                    <apexchart 
                      height="275" 
                      :options="bar.chartOptions" 
                      :series="bar.series">
                    </apexchart>
                  </div>
                </v-col>
                <v-col cols="12" md="4" class="py-0">
                  <v-card-title class="caption green--text">
                    TOTAL DP
                  </v-card-title>
                  <v-card-subtitle class="font-weight-bold" v-if="Object.keys(detail).length > 0">
                    {{ parseInt(detail.down_payment.total) | price }}
                  </v-card-subtitle>
                  <v-card-text>
                    <v-simple-table>
                      <template v-slot:default>
                        <tbody>
                          <tr v-for="(item, index) in trafic" 
                            :key="index">
                            <td class="caption text-second px-0">
                              <p class="mb-0" :class="index === 0 ? 'teal--text' : index === 1 ? 'orange--text' : 'red--text'"
                                style="font-size: 10px;">
                                {{ item.title }}
                              </p>
                              {{ parseInt(item.value) | price }}
                            </td>
                            <td class="caption text-second d-flex justify-end align-end text-right px-0 py-1">
                              {{ parseFloat(item.percentage) }} %
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="4">
        <v-row>
          <v-col>
            <v-card
              class="box-shadow border-radius">
              <v-card-title class="body-2 text-second">
                Ringkasan Proyek
              </v-card-title>
              <v-card-subtitle class="caption text-third">
                Sampai Dengan <b>{{ dateNow | date }}</b>
              </v-card-subtitle>
              <v-card-text class="d-flex align-center mt-3">
                <v-avatar tile>
                  <v-img
                    :src="require('../../assets/image/icon-home.png')">
                  </v-img>
                </v-avatar>
                <div class="mx-3">
                  <span class="title text-second">
                    {{ detail.project_total }}
                  </span>
                  <span class="caption text-third">
                    Proyek / <!-- <b>{{ detail.project_unit_type_total }}</b> Unit Tipe / --><b>{{ detail.project_unit_total }}</b> Unit
                  </span>
                </div>
              </v-card-text>
              <v-card-text>
                <v-simple-table style="min-height: 145px;">
                  <template v-slot:default>
                    <tbody>
                      <tr v-for="(item, index) in summary" 
                        :key="index">
                        <td class="caption text-second px-0" width="180">
                          {{ item.title }}
                        </td>
                        <td class="caption text-second">
                          <span :class="index === 0 ? 'teal--text' : index === 1 ? 'orange--text' : 'green--text'">
                            {{ item.unit }}
                          </span>
                          Unit
                        </td>
                        <td class="caption text-second text-right px-0">
                          {{ item.prcentage }} %
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <v-divider/>
              </v-card-text>
              <!-- <router-link to="/project" v-if="summary.length > 0">
                <v-card-text class="caption text-third" style="font-size: 10px;">
                  Lihat semua proyek
                </v-card-text>
              </router-link> -->
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="4">
        <v-skeleton-loader
          class="ma-auto"
          :loading="process.run"
          transition="scale-transition"
          :tile="true"
          type="card">
          <v-card
            min-height="300"
            class="box-shadow border-radius pa-2">
            <v-card-text class="subtitle-2 text-second">
              Total Unit
            </v-card-text>
            <apexchart
              :height="$vuetify.breakpoint.name === 'lg' || $vuetify.breakpoint.name === 'md' ? 200 : 300"
              :options="pie.unit.chartOptions" 
              :series="pie.unit.series">
            </apexchart>
          </v-card>
        </v-skeleton-loader>
      </v-col>
      <v-col cols="12" md="4">
        <v-skeleton-loader
          class="ma-auto"
          :loading="process.run"
          transition="scale-transition"
          :tile="true"
          type="card">
          <v-card
            min-height="300"
            class="box-shadow border-radius pa-2">
            <v-card-text class="subtitle-2 text-second">
              Total PPJB
            </v-card-text>
            <apexchart
              :height="$vuetify.breakpoint.name === 'lg' || $vuetify.breakpoint.name === 'md' ? 200 : 300"
              :options="pie.ppjbajb.chartOptions" 
              :series="pie.ppjbajb.series">
            </apexchart>
          </v-card>
        </v-skeleton-loader>
      </v-col>
      <v-col cols="12" md="4">
        <v-skeleton-loader
          class="ma-auto"
          :loading="process.run"
          transition="scale-transition"
          :tile="true"
          type="card">
          <v-card
            min-height="300"
            class="box-shadow border-radius pa-2">
            <v-card-text class="subtitle-2 text-second">
              Total Tempo
            </v-card-text>
            <apexchart
              :height="$vuetify.breakpoint.name === 'lg' || $vuetify.breakpoint.name === 'md' ? 200 : 300"
              :options="pie.tempo.chartOptions"
              :series="pie.tempo.series">
            </apexchart>
          </v-card>
        </v-skeleton-loader>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="4">
        <v-card
          min-height="335"
          class="box-shadow border-radius">
          <v-card-title class="body-2 text-second">
            Marketing Penjualan Terbanyak (PPJB)
          </v-card-title>
          <v-card-subtitle class="caption text-third">
            Sampai Dengan <b>{{ dateNow | date }}</b>
          </v-card-subtitle>
          <v-card-text>
            <v-simple-table style="min-height: 195px;" v-if="Object.keys(detail).length > 0 && detail.ppjb.length > 0">
              <template v-slot:default>
                <tbody>
                  <tr v-for="(item, index) in detail.ppjb" 
                    :key="index">
                    <td class="caption text-second px-0">
                      {{ item.user_name }}
                    </td>
                    <td class="caption text-second d-flex align-center justify-end">
                      <span class="mr-2 font-weight-bold">
                        {{ item.unit }}
                      </span>
                      <v-avatar tile size="15">
                        <v-img
                          :src="require('../../assets/image/icon-home.png')">
                        </v-img>
                      </v-avatar>
                    </td>
                    <td class="caption text-second text-right px-0">
                      {{ parseInt(item.nominal) | price }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <div v-if="Object.keys(detail).length > 0 && detail.ppjb.length < 1"
              class="d-flex align-center text-center text--secondary" style="min-height: 195px;">
              <v-img 
                contain
                width="75"
                height="75"
                :src="require('../../assets/404/404.svg')">
              </v-img>
            </div>
          </v-card-text>
          <v-card-text class="caption text-third cursor-pointer" style="font-size: 10px;"
            v-if="Object.keys(detail).length > 0 && detail.ppjb.length > 3"
            @click="dialog.marketing = true; filter.marketing = 'ppjb'; fetchPpjbajb();">
            Lihat semua
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card
          min-height="335"
          class="box-shadow border-radius">
          <v-card-title class="body-2 text-second">
            Marketing Penjualan Terbanyak (AJB)
          </v-card-title>
          <v-card-subtitle class="caption text-third">
            Sampai Dengan <b>{{ dateNow | date }}</b>
          </v-card-subtitle>
          <v-card-text>
            <v-simple-table style="min-height: 195px;" v-if="Object.keys(detail).length > 0 && detail.ajb.length > 0">
              <template v-slot:default>
                <tbody>
                  <tr v-for="(item, index) in detail.ajb" 
                    :key="index">
                    <td class="caption text-second px-0">
                      {{ item.user_name }}
                    </td>
                    <td class="caption text-second d-flex align-center justify-end">
                      <span class="mr-2 font-weight-bold">
                        {{ item.unit }}
                      </span>
                      <v-avatar tile size="15">
                        <v-img
                          :src="require('../../assets/image/icon-home.png')">
                        </v-img>
                      </v-avatar>
                    </td>
                    <td class="caption text-second text-right px-0">
                      {{ parseInt(item.nominal) | price }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <div v-if="Object.keys(detail).length > 0 && detail.ajb.length < 1"
              class="d-flex align-center text-center text--secondary" style="min-height: 195px;">
              <v-img 
                contain
                width="75"
                height="75"
                :src="require('../../assets/404/404.svg')">
              </v-img>
            </div>
          </v-card-text>
          <v-card-text class="caption text-third cursor-pointer" style="font-size: 10px;"
            v-if="Object.keys(detail).length > 0 && detail.ajb.length > 4"
            @click="dialog.marketing = true; filter.marketing = 'ajb'; fetchPpjbajb();">
            Lihat semua
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card
          min-height="335"
          class="box-shadow border-radius">
          <v-card-title class="body-2 text-second">
            Unit Yang Banyak Terjual
          </v-card-title>
          <v-card-subtitle class="caption text-third">
            Sampai Dengan <b>{{ dateNow | date }}</b>
          </v-card-subtitle>
          <v-card-text>
            <v-simple-table style="min-height: 195px;" v-if="Object.keys(detail).length > 0 && detail.unit_sold.length > 0">
              <template v-slot:default>
                <tbody>
                  <tr v-for="(item, index) in detail.unit_sold" 
                    :key="index">
                    <td class="caption text-second px-0">
                      {{ item.project_name }} - {{ item.unit_type_name }}
                    </td>
                    <td class="caption text-second d-flex align-center justify-end">
                      {{ item.unit_type_sold_unit }} / {{ item.unit_type_total_unit }} Unit
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <div v-if="Object.keys(detail).length > 0 && detail.unit_sold.length < 1"
              class="d-flex align-center text-center text--secondary" style="min-height: 195px;">
              <v-img 
                contain
                width="75"
                height="75"
                :src="require('../../assets/404/404.svg')">
              </v-img>
            </div>
          </v-card-text>
          <v-card-text class="caption text-third cursor-pointer" style="font-size: 10px;"
            v-if="Object.keys(detail).length > 0 && detail.unit_sold.length > 4"
            @click="dialog.unit = true; fetchUnit();">
            Lihat semua
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>

  <!--
  <div v-else-if="user.role != 'superuser'" class="my-5" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-9' : 'px-5'">
    <h3>Selamat Datang, {{ user.name }}!</h3>
  </div>
  -->
</template>

<script>
  import { get, post, put, destroy } from "../../service/Axios";
  import moment from 'moment';
  import 'moment/locale/id';
  export default {
    data () {
      return {
        selected: {
          pagination: 1
        },
        dateNow: moment().format('Y-MM-DD'),
        monthNow: moment.months(),
        yearNow: new Date().getFullYear(),
        picker: {
          start: false,
          end: false
        },
        dialog: {
          marketing: false,
          ppjbajb: false,
          unit: false,
          filter: false
        },
        filter: {
          project_id: '',
          year: new Date().getFullYear(),
          month: 0,
          marketing: '',
          dialog: {
            year_start: new Date().getFullYear(),
            year_end: new Date().getFullYear(),
            month_start: 1,
            month_end: 1,
            date_start: '',
            date_end: '',
            periode: 'year'
          }
        },
        type: [
          {
            label: 'Tahun',
            value: 'year'
          },
          {
            label: 'Bulan',
            value: 'month'
          },
          {
            label: 'Tanggal',
            value: 'date'
          }
        ],
        detail: {},
        detailPpjbajb: {},
        project: [
          {
            project_id: '',
            project_name: 'Semua Proyek'
          }
        ],
        top: [],
        summary: [],
        trafic: [],
        marketing: [
          {
            title: "Bu Kristi",
            unit: 35,
            value: 3546000000
          },
          {
            title: "Aris Darmawan",
            unit: 11,
            value: 1353344000
          },
          {
            title: "Alam",
            unit: 2,
            value: 580000000
          },
          {
            title: "John",
            unit: 1,
            value: 250000000
          }
        ],
        list: [],
        listDetail: [],
        pagination: {},
        bar: {
          series: [],
          chartOptions: {
            chart: {
              animations: {
                enabled: true,
                easing: 'linear',
                dynamicAnimation: {
                  speed: 1000
                }
              },
              toolbar: {
                show: true
              },
              zoom: {
                enabled: true
              }
            },
            stroke: {
              width: 3,
              curve: 'smooth'
            },
            dataLabels: {
              enabled: false
            },
            colors: ['#009688', '#FF9800', '#F44336'],
            yaxis: {
              labels: {
                formatter: function (value) {
                  if (isNaN(value)) return 'Not a Number'
                  let price = ''
                  const reverseNumber = value
                    .toString()
                    .split('')
                    .reverse()
                    .join('')
                  const arrReverseNumber = [...Array(reverseNumber.length).keys()]
                  arrReverseNumber.map(index => {
                    if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
                  })

                  return `Rp ${
                    price.split('', price.length - 1)
                    .reverse()
                    .join('')
                  }`
                }
              }
            },
            xaxis: {
              categories: []
            }
          }
        },
        pie: {
          unit: {
            series: [],
            chartOptions: {
              chart: {
                width: 320,
                type: 'donut',
              },
              labels: [],
              colors: ['#CFD8DC', '#FF9800', '#4FC3F7', '#f44336'],
              dataLabels: {
                enabled: true,
                formatter: function (val) {
                  return Number.parseFloat(val).toFixed(1) + "%"
                }
              },
              legend: {
                position: 'right'
              },
              plotOptions: {
                pie: {
                  donut: {
                    labels: {
                      show: true,
                      value: {
                        show: true,
                        fontSize: '12px',
                        fontWeight: 'bold'
                      },
                      total: {
                        showAlways: true,
                        show: true,
                        fontSize: '12px',
                        formatter: function (w) {
                          return w.globals.seriesTotals.reduce((a, b) => {
                            return parseInt(a) + parseInt(b)
                          }, 0)
                        }
                      }
                    }
                  }
                }
              },
              responsive: [{
                breakpoint: 450,
                options: {
                  chart: {
                    width: 300
                  },
                  legend: {
                    position: 'bottom'
                  }
                }
              }]
            }
          },
          ppjbajb: {
            series: [],
            chartOptions: {
              chart: {
                width: 320,
                type: 'donut',
              },
              labels: [],
              colors: ['#4FC3F7', '#F44336'],
              dataLabels: {
                enabled: true,
                formatter: function (val) {
                  return Number.parseFloat(val).toFixed(1) + "%"
                }
              },
              legend: {
                position: 'right'
              },
              plotOptions: {
                pie: {
                  donut: {
                    labels: {
                      show: true,
                      value: {
                        show: true,
                        fontSize: '12px',
                        fontWeight: 'bold'
                      },
                      total: {
                        showAlways: true,
                        show: true,
                        fontSize: '12px',
                        formatter: function (w) {
                          let value = w.globals.seriesTotals.reduce((a, b) => {
                            return parseInt(a) + parseInt(b)
                          }, 0)
                          
                          if (isNaN(value)) return 'Not a Number'
                          let price = ''
                          const reverseNumber = value
                            .toString()
                            .split('')
                            .reverse()
                            .join('')
                          const arrReverseNumber = [...Array(reverseNumber.length).keys()]
                          arrReverseNumber.map(index => {
                            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
                          })

                          return `Rp ${
                            price.split('', price.length - 1)
                            .reverse()
                            .join('')
                          }`
                        }
                      }
                    }
                  }
                }
              },
              responsive: [{
                breakpoint: 450,
                options: {
                  chart: {
                    width: 300
                  },
                  legend: {
                    position: 'bottom'
                  }
                }
              }],
              tooltip: {
                y: {
                  formatter: function(value) {
                    //
                    if (isNaN(value)) return 'Not a Number'
                    let price = ''
                    const reverseNumber = value
                      .toString()
                      .split('')
                      .reverse()
                      .join('')
                    const arrReverseNumber = [...Array(reverseNumber.length).keys()]
                    arrReverseNumber.map(index => {
                      if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
                    })

                    return `Rp ${
                      price.split('', price.length - 1)
                      .reverse()
                      .join('')
                    }`
                    //
                  }
                }
              }
            }
          },
          tempo: {
            series: [],
            chartOptions: {
              chart: {
                width: 320,
                type: 'donut',
              },
              labels: [],
              colors: ['#FF9800', '#F44336'],
              dataLabels: {
                enabled: true,
                formatter: function (val) {
                  return Number.parseFloat(val).toFixed(1) + "%"
                }
              },
              legend: {
                position: 'right'
              },
              plotOptions: {
                pie: {
                  donut: {
                    labels: {
                      show: true,
                      value: {
                        show: true,
                        fontSize: '12px',
                        fontWeight: 'bold'
                      },
                      total: {
                        showAlways: true,
                        show: true,
                        fontSize: '12px',
                        formatter: function (w) {
                          let value = w.globals.seriesTotals.reduce((a, b) => {
                            return parseInt(a) + parseInt(b)
                          }, 0)
                          
                          if (isNaN(value)) return 'Not a Number'
                          let price = ''
                          const reverseNumber = value
                            .toString()
                            .split('')
                            .reverse()
                            .join('')
                          const arrReverseNumber = [...Array(reverseNumber.length).keys()]
                          arrReverseNumber.map(index => {
                            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
                          })

                          return `Rp ${
                            price.split('', price.length - 1)
                            .reverse()
                            .join('')
                          }`
                        }
                      }
                    }
                  }
                }
              },
              responsive: [{
                breakpoint: 450,
                options: {
                  chart: {
                    width: 300
                  },
                  legend: {
                    position: 'bottom'
                  }
                }
              }],
              tooltip: {
                y: {
                  formatter: function(value) {
                    //
                    if (isNaN(value)) return 'Not a Number'
                    let price = ''
                    const reverseNumber = value
                      .toString()
                      .split('')
                      .reverse()
                      .join('')
                    const arrReverseNumber = [...Array(reverseNumber.length).keys()]
                    arrReverseNumber.map(index => {
                      if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
                    })

                    return `Rp ${
                      price.split('', price.length - 1)
                      .reverse()
                      .join('')
                    }`
                    //
                  }
                }
              }
            }
          }
        },
        process: {
          run: false,
          detail: false
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    computed: {
      years_starts () {
        let year = []
        for (let i = this.yearNow; i >= this.yearNow - 30; i-=1) {
          year.push(i)
        }
        return year
      },
      years_ends () {
        let year = [], start = this.filter.dialog.year_start === this.yearNow ? 0 : this.yearNow - this.filter.dialog.year_start

        for (let i = this.yearNow; i >= this.yearNow - start; i-=1) {
          year.push(i)
        }
        return year
      },
      months_starts () {
        let month = this.dialog.marketing ? [{
          label: 'Semua Bulan',
          value: 0
        }] : []

        for (let i in this.monthNow) {
          month.push({
            label: this.monthNow[i],
            value: parseInt(i) + 1
          })
        }
        return month
      },
      months_ends () {
        let month = this.dialog.marketing ? [{
          label: 'Semua Bulan',
          value: 0
        }] : [], start = this.filter.dialog.month_start === 0 ? this.monthNow : this.filter.dialog.month_start
        
        for (let i in this.monthNow) {
          if (i >= start - 1) {
            month.push({
              label: this.monthNow[i],
              value: parseInt(i) + 1
            })
          }
        }
        return month
      },
      user () {
        return this.$store.state.user
      },
    },
    watch: {
      'filter.project_id': function(val) {
        if (!this.dialog.unit) {
          if (!this.dialog.marketing) {
            this.fetchDashboard()
          } else {
            this.fetchPpjbajb()
          }
        } else {
          this.fetchUnit()
        }
      },
      'filter.year': function(val) {
        this.fetchPpjbajb()
      },
      'filter.month': function(val) {
        this.fetchPpjbajb()
      },
      'selected.pagination': function(val) {
        if (!this.dialog.unit) {
          this.fetchPpjbajb(val)
        } else {
          this.fetchUnit(val)
        }
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      fetch() {
        get(`auth/company/project/list-option`)
        .then(response => {
          let res = response.data
          if (res.status == 200) {
            this.project = this.project.concat(res.data.results)

            this.fetchDashboard()
          }
        })
      },
      fetchDashboard() {
        this.process.run = true

        console.log(this.filter.dialog)

        let params = {
          limit: 4,
          project_id: this.filter.project_id,
          year_start: this.filter.dialog.year_start,
          year_end: this.filter.dialog.year_end,
          month_start: this.filter.dialog.month_start,
          month_end: this.filter.dialog.month_end,
          date_start: this.filter.dialog.date_start,
          date_end: this.filter.dialog.date_end,
          periode: this.filter.dialog.periode
        }

        get(`auth/dashboard/project`, { params })
        .then(response => {
          let res = response.data
          if (res.status == 200) {
            this.process.run = false

            this.detail = res.data

            this.top = [
              {
                icon: "mdi-folder-home-outline",
                project: {
                  title: "Total Proyek",
                  total: this.detail.project_total
                },
                type: {
                  title: "Total Unit",
                  total: this.detail.project_unit_total,
                  color: "green"
                },
                unit: {
                  title: "Unit Tersedia",
                  total: this.detail.total_unit_avaliable,
                  color: "teal"
                },
                // type: {
                //   title: "Total Tipe Unit",
                //   total: this.detail.project_unit_type_total,
                //   color: "teal"
                // },
                // unit: {
                //   title: "Total Unit",
                //   total: this.detail.project_unit_total,
                //   color: "green"
                // },
                color: this.style.primary,
                desc: "Total proyek, unit, dan unit tersedia."
              },
              {
                icon: "mdi-home-import-outline",
                project: {
                  title: this.$vuetify.breakpoint.name === 'lg' ? 'Pengajuan Boking Unit' : 'Peng. Booking Unit',
                  total: this.detail.total_pengajuan
                },
                type: {
                  title: "Pengajuan Pending",
                  total: this.detail.total_pengajuan_pending,
                  color: "orange"
                },
                unit: {
                  title: "Pengajuan Disetujui",
                  total: this.detail.total_pengajuan_approve,
                  color: "teal"
                },
                color: "#FFB74D",
                desc: "Total dari pengajuan boking unit dari yang diajukan sampai yang disetujui."
              },
              {
                icon: "mdi-home-circle-outline",
                project: {
                  title: "Proses Akad Unit",
                  total: this.detail.total_unit_ajb
                },
                type: {
                  title: this.$vuetify.breakpoint.name === 'lg' ? 'Proses Pembangunan' : 'Proses Bangun',
                  total: this.detail.progress_pembangunan,
                  color: "orange"
                },
                unit: {
                  title: this.$vuetify.breakpoint.name === 'lg' ? 'Pembangunan Selesai' : 'Bangunan Selesai',
                  total: this.detail.progress_selesai,
                  color: "green"
                },
                color: "#4DB6AC",
                desc: "Proses pemberkasan sampai akad dan proses pembangunan unit sampai selesai."
              }
            ]

            let dataSummary = ['Tersedia', 'Pengajuan Pending', 'Proses PPJB', 'Proses AJB']
            this.summary = []
            dataSummary.forEach(item => {
              this.summary.push({
                title: item,
                unit: item === 'Tersedia' ? this.detail.total_unit_avaliable : item === 'Pengajuan Pending' ? this.detail.total_unit_pending : item === 'Proses PPJB' ? this.detail.total_unit_ppjb : this.detail.total_unit_ajb,
                prcentage: item === 'Tersedia' ? this.detail.total_unit_avaliable_persen : item === 'Pengajuan Pending' ? this.detail.total_unit_pending_persen : item === 'Proses PPJB' ? this.detail.total_unit_ppjb_persen : this.detail.total_unit_ajb_persen
              })
            })

            this.trafic = [
              {
                title: 'Lunas',
                value: this.detail.down_payment.paid,
                percentage: this.detail.down_payment.paid_persen,
                color: 'teal'
              },
              {
                title: 'Jatuh Tempo',
                value: this.detail.down_payment.due_date,
                percentage: this.detail.down_payment.due_date_persen,
                color: 'orange'
              },
              {
                title: 'Belum Jatuh Tempo',
                //value: this.detail.down_payment.waiting_payment,
                //percentage: this.detail.down_payment.waiting_payment_persen,
                value: this.detail.down_payment.before_due_date,
                percentage: this.detail.down_payment.before_due_date_persen,
                color: 'red'
              }
            ]
            
            this.bar = {
              series: this.detail.income_chart.series,
              chartOptions: {
                chart: {
                  animations: {
                    enabled: true,
                    easing: 'linear',
                    dynamicAnimation: {
                      speed: 1000
                    }
                  },
                  toolbar: {
                    show: true
                  },
                  zoom: {
                    enabled: true
                  }
                },
                stroke: {
                  width: 3,
                  curve: 'smooth'
                },
                dataLabels: {
                  enabled: false
                },
                colors: ['#009688', '#FF9800', '#F44336'],
                xaxis: {
                  categories: this.detail.income_chart_label
                }
              }
            }
          
            this.pie.unit.series = this.detail.unit_chart.series
            this.pie.unit.chartOptions.labels = this.detail.unit_chart.labels

            this.pie.ppjbajb.series = this.detail.down_payment_chart.series
            this.pie.ppjbajb.chartOptions.labels = this.detail.down_payment_chart.labels

            this.pie.tempo.series = this.detail.down_payment_unpaid_chart.series
            this.pie.tempo.chartOptions.labels = this.detail.down_payment_unpaid_chart.labels
          }
        })
      },
      reset() {
        this.filter = {
          project_id: '',
          year: new Date().getFullYear(),
          month: 0,
          marketing: '',
          dialog: {
            year_start: new Date().getFullYear(),
            year_end: new Date().getFullYear(),
            month_start: 1,
            month_end: 1,
            date_start: '',
            date_end: '',
            periode: 'year'
          }
        }
      },
      fetchPpjbajb(p) {
        this.process.run = true

        let params = {
          page: p,
          limit: 7,
          project_id: this.filter.project_id,
          year: this.filter.year,
          month: this.filter.month
        }

        get(`auth/dashboard/marketing/${this.filter.marketing}`, { params })
        .then(response => {
          let res = response.data
          if (res.status == 200) {
            this.process.run = false
            this.list = res.data.results
            this.pagination = res.data.pagination
            this.pagination.current = parseInt(this.pagination.current)
          }
        })
      },
      fetchPpjbajbDetail() {
        this.process.detail = true
        
        let params = {
          limit: 10000,
          project_id: this.filter.project_id,
          user_id: this.detailPpjbajb.user_id
        }

        get(`auth/dashboard/marketing/${this.filter.marketing}-per-unit-type`, { params })
        .then(response => {
          let res = response.data
          if (res.status == 200) {
            this.process.detail = false
            this.listDetail = res.data.results
          }
        })
      },
      fetchUnit(p) {
        this.process.run = true

        let params = {
          page: p,
          limit: 7,
          project_id: this.filter.project_id
        }

        get(`auth/dashboard/top-unit-selling`, { params })
        .then(response => {
          let res = response.data
          if (res.status == 200) {
            this.process.run = false
            this.list = res.data.results
            this.pagination = res.data.pagination
            this.pagination.current = parseInt(this.pagination.current)
          }
        })
      },
      pricing(num) {
        if (isNaN(num)) return "Not a Number"
        let price = ""
        const reverseNumber = num
          .toString()
          .split("")
          .reverse()
          .join("")
        const arrReverseNumber = [...Array(reverseNumber.length).keys()]
        arrReverseNumber.map(index => {
          if (index % 3 === 0) price += reverseNumber.substr(index, 3) + "."
        })

        return `${
          price.split("", price.length - 1)
          .reverse()
          .join("")
        }`
      }
    }
  }
</script>

<style scoped>
.border-h{
  min-width: 555px !important;
  max-width: 100% !important;
}
</style>